var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCartWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 2.33334H4.3635C5.6235 2.33334 6.61516 3.41834 6.51016 4.66668L5.54183 16.2867C5.3785 18.1883 6.88349 19.8217 8.79682 19.8217H21.2218C22.9018 19.8217 24.3718 18.445 24.5002 16.7767L25.1302 8.02668C25.2702 6.09002 23.8002 4.515 21.8518 4.515H6.79017",
    stroke: "white",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 25.6667C19.7637 25.6667 20.4167 25.0137 20.4167 24.2083C20.4167 23.4029 19.7637 22.75 18.9583 22.75C18.1529 22.75 17.5 23.4029 17.5 24.2083C17.5 25.0137 18.1529 25.6667 18.9583 25.6667Z",
    stroke: "white",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62484 25.6667C10.4303 25.6667 11.0832 25.0137 11.0832 24.2083C11.0832 23.4029 10.4303 22.75 9.62484 22.75C8.81942 22.75 8.1665 23.4029 8.1665 24.2083C8.1665 25.0137 8.81942 25.6667 9.62484 25.6667Z",
    stroke: "white",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.33331H24.5",
    stroke: "white",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartWhite);
export default __webpack_public_path__ + "static/media/shopping-cart-white.6597a05e4e12dbd41ee27c8cbf1ad8b3.svg";
export { ForwardRef as ReactComponent };